<template>
  <div class="status-selector" id="status-selector">
    <div class="pa-block">
      <div class="pa-block__inner">
        <label for="status"> Status ({{ classified.status }}) </label>
        <select name="status" id="status" v-model="status">
          <option value="draft">Brouillon</option>
          <option value="publish">Publiée</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "status-selector",
  components: {},
  computed: {
    ...mapGetters(["classified", "isAdmin", "isDev"]),
    status: {
      get() {
        return this.classified.status;
      },
      set(status) {
        this.$store.commit("setStatus", status);
      },
    },
  },
  methods: {
    handleSubmit(result) {
      this.$store.commit("setStatus", result.ID);
    },
  },
};
</script>
